export default __webpack_public_path__ + "static/media/cp_geo_sg.74fddb13.svg";